// categoryMapping.js
export const CATEGORY_MAP = {
  "FROMAGE VACHE pate dur et mi-dur": "FROMAGE VACHE pate dur et mi-dur",
  "Fromage Brebis": "fromage_brebis",
  "Fromage Chèvre": "fromage_chevre",
  Charcuterie: "charcuterie",
  "Produit Laitier": "produit_laitier",
  "Panier Garni": "panier_garni",
};
